import * as React from "react";
import styled, { css } from "../../../styled/index";
import { CS } from "../../../styles/index";
import {shadeAlternate} from "../../../styled/helpers";

export interface TabSelectProps extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
  active: boolean;
  width: ThemeContentSizes | "full";
  close: () => void;
}

export const TabSelectComponent = styled("div")<{ background: string; hasBorder?: boolean; }>`
  position: relative;
  overflow: hidden;
  background: ${({background}) => background};
  user-select: none;
  width: 100%;
  height: ${({hasBorder}) => hasBorder ? 44 : 42}px;
  z-index: ${({theme}) => theme.slide_panel.zindex};
`;

export const TabSelectControlComponent = styled("div")<{ background: string; hide?: boolean; side: "left" | "right" }>`
  z-index: 1;
  display: ${({hide}) => hide ? "none" : "flex"};
  justify-content: center;
  align-items: center;
  background: ${({background}) => background};
  position: absolute;
  height: 42px;
  width: 32px;
  cursor: pointer;
  ${({side, background}) => side === "left" ? css`
    left: 0;
    border-right: 1px solid ${shadeAlternate(0.1, background)};
  ` : css`
    right: 0;
    border-left: 1px solid ${shadeAlternate(0.1, background)};
  `};
`;

export const TabSelectHighlightComponent = styled("div")<{ startPosition: number; width: number; }>`
  position: absolute;
  border-bottom: 2px solid ${({theme}) => theme.colors.primary};
  transition: all 0.3s ease;
  top: 40px;
  transform: translateX(${({startPosition}) => startPosition}px);
  width: ${({width}) => width}px;
`;

export const TabSelectContentComponent = styled("div")<{ position: number; }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  line-height: 0;
  transition: 0.3s all;
  transform: translateX(${({position}) => position}px);
`;

export const TabSelectOptionsComponent = styled("div")`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  transition: 0.3s all;
`;

export const TabSelectOptionComponent = styled("div")<{ hidden?: boolean; }>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  padding: 0 12px;
  height: 39px;
  visibility: ${({hidden}) => hidden ? "hidden" : "visible"};
`;
